import React from 'react';

import s from './styles.module.scss';

type ChartItem = {
  label: string;
  value: number;
};

type ChartCardItemProps = {
  title: string;
  items: ChartItem[];
};

const ChartCardItem: React.FC<ChartCardItemProps> = ({ title, items }) => {
  const total = items.reduce((acc, item) => acc + item.value, 0);
  const itemsWithPercent = items.map((item) => ({
    ...item,
    percent: total > 0 ? (item.value / total) * 100 : 0,
  }));

  const maxPercent = Math.min(
    100,
    Math.ceil(Math.max(...itemsWithPercent.map((i) => i.percent)) / 10) * 10,
  );

  const gridSteps = Array.from(
    { length: Math.floor(maxPercent / 10) + 1 },
    (_, i) => i * 10,
  );

  return (
    <div>
      <div className={s['question-header']}>
        <p>- {title}</p>
      </div>

      <div className={s.chart}>
        <div className={s.grid}>
          {gridSteps.map((p) => (
            <div key={p} className={s['grid-line']}>
              <span>{p}%</span>
            </div>
          ))}
        </div>

        {itemsWithPercent.map((item, idx) => (
          <div className={s.row} key={idx}>
            <div className={s.label}>{item.label}</div>
            <div className={s.value}>{item.value}</div>
            <div className={s['bar-area']}>
              <div className={s['bar-track']}>
                <div
                  className={s['bar-fill']}
                  style={{ width: `${(item.percent / maxPercent) * 100}%` }}
                />
              </div>
            </div>
            <div className={s.percent}>{item.percent.toFixed(2)}%</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChartCardItem;
